import { type PropsWithChildren, type ReactNode, Suspense } from 'react';

import { FlagResolverProvider } from '../../context';
import { OpenFeatureBoundary, useOpenFeatureFlagValue } from '../../vendor';

export type FlagEvaluationProviderProps = PropsWithChildren<{
  fallback: ReactNode;
}>;

export const FlagEvaluationProvider = ({
  children,
  fallback,
}: FlagEvaluationProviderProps) => (
  <OpenFeatureBoundary>
    <FlagResolverProvider resolver={useOpenFeatureFlagValue}>
      <Suspense fallback={fallback}>{children}</Suspense>
    </FlagResolverProvider>
  </OpenFeatureBoundary>
);
